import { addOptionalToSchema, idSchema } from '@common/schema';
import * as yup from 'yup';

export const editPatientSchema = yup.object().shape({
  salesforce_id: addOptionalToSchema(idSchema),
  canvas_id: addOptionalToSchema(idSchema),
  emr_id: addOptionalToSchema(idSchema),
  billing_id: addOptionalToSchema(idSchema),
  care_connect_id: addOptionalToSchema(idSchema),
  care_connect_link: addOptionalToSchema(idSchema),
  customer_id: addOptionalToSchema(
    idSchema.max(
      20,
      'Character limit exceeded. Please shorten your entry to 20 characters.',
    ),
  ),
  cms_iso_id: addOptionalToSchema(
    idSchema.max(
      10,
      'Character limit exceeded. Please shorten your entry to 10 characters.',
    ),
  ),
});
